




















import {Vue, Component} from 'vue-property-decorator'
import Footers from '@/components/Footers.vue'

@Component({
  name: 'MemberNotFound',
  components: {Footers}
})
export default class MemberNotFound extends Vue {
  private onClickClose(){
    window.close();
  }
}
